import { Routes, Route, useLocation } from 'react-router-dom';
import SidebarLayout from './components/SidebarLayout';
import ErrorBoundary from './components/ErrorBoundary';
import BestsellerManager from './components/BestsellerManager';
import DiscountManager from './components/DiscountManager';
import OrderManager from './components/OrderManager';
import UserManager from './components/UserManager';
import Dashboard from './components/Dashboard';
import Login from './components/auth/Login';
import ProtectedRoute from './components/auth/ProtectedRoute';
import ProductManager from './components/ProductManager';
import DeletedProductsManager from './components/DeletedProductsManager';
import ProductDetails from './components/ProductDetails';
import StatisticsPage from './components/StatisticsPage';

function App() {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <SidebarLayout>
              {/* Keyed by path so a page that throws resets when the admin
                  navigates elsewhere, while the sidebar shell stays alive. */}
              <ErrorBoundary key={location.pathname}>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/statistics" element={<StatisticsPage />} />
                  <Route path="/users" element={<UserManager />} />
                  <Route path="/orders" element={<OrderManager />} />
                  <Route path="/bestsellers" element={<BestsellerManager />} />
                  <Route path="/discounts" element={<DiscountManager />} />
                  <Route path="/products" element={<ProductManager />} />
                  <Route path="/products/deleted" element={<DeletedProductsManager />} />
                  <Route path="/products/:pharmacode" element={<ProductDetails />} />
                </Routes>
              </ErrorBoundary>
            </SidebarLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;